import React from "react"

import TextBox from "../components/textbox"

import ExternalLink from "../components/external-link"
import * as variables from "../shared/variables"
import CreditPage from "./credit"
import SEO from "../components/seo"

require('typeface-kanit')

const Interview = () => {
    return <div css={{ padding: "10px" }}>
        <SEO title="บทสัมภาษณ์ พิศิษฐ์ ลีลาวชิโรภาส (อดีตผู้ว่าฯ สตง.) เกี่ยวกับรูปแบบการจัดซื้อจัดจ้าง และสะท้อนการตรวจสอบงบจัดซื้อจัดจ้าง จากประสบการณ์ที่ผ่านมา"/>
        <TextBox>
            <h1 css={{
                    paddingTop: "20vh",
                }}
            >บทสัมภาษณ์ พิศิษฐ์ ลีลาวชิโรภาส (อดีตผู้ว่าฯ สตง.) เกี่ยวกับรูปแบบการจัดซื้อจัดจ้าง และสะท้อนการตรวจสอบงบจัดซื้อจัดจ้าง จากประสบการณ์ที่ผ่านมา
            </h1>
            <div css={{fontSize: "0.8em"}}>
                <b>โดย: </b>{variables.teamMembers.join(', ')}
                <div css={{marginTop: "5px"}}>
                    <b>วันที่: </b>{variables.date}
                </div>
            </div>
            <p>
            ทีมข่าวกลุ่มการเมือง TDJ สัมภาษณ์พิเศษ นายพิศิษฐ์ ลีลาวชิโรภาส อดีตผู้ว่าการตรวจเงินแผ่นดิน (สตง.) ถึง “ความเชื่อมโยง” และสมมุติฐานความเกี่ยวข้องกันระหว่าง “รูปแบบการจัดซื้อจัดจ้าง” กับ “การใช้จ่ายโครงการที่เกี่ยวข้องกับการโยธา” ว่ามีความสัมพันธ์ในเรื่องความคุ้มค่าของการใช้จ่ายงบประมาณส่วนท้องถิ่นหรือไม่ อย่างไร
            </p>
            <p>
            คำตอบของอดีตผู้ว่า สตง. ได้ขยายข้อสมมุติฐานข้อมูลได้ว่า ช่องว่างการใช้วิจารณญาณของท้องถิ่นในการตัดสินใจว่าโครงการจะใช้รูปแบบการจัดซื้อจัดจ้างแบบใด โดยเฉพาะรูปแบบเฉพาะเจาะจง (ที่ไม่มีผู้ประมูลแข่งขัน) ยังพบปัญหา
            ในการใช้งบประมาณก็มีการหลบเลี่ยง บางอย่างไม่ควรเจาะจงก็ทำ ระบบ e-bidding อย่าไปคิดว่ามันไม่มีปัญหา อาจจะซ่อนปัญหาไว้ก็ได้ เช่น โอเวอร์สเปก เขียนราคาให้สูง แล้วเวลาส่งมอบกลับได้ของอีกเกรดหนึ่ง ซึ่งส่วนต่างอาจกลับมาเป็นเงินทอน 
            </p>
            <p>
                คอนกรีตกับลูกรังเป็นสองกรณีที่พบปัญหาบ่อยมาก งานก่อสร้างมักจะสะท้อนปัญหาสร้างแล้วก็พัง สร้างแล้วไม่ได้ใช้ประโยชน์ แล้วก็ถนนลูกรังชอบมากที่สุด ปัญหาถนนลูกรังก็คือ ตรวจสอบยาก เช่น เทดินลูกรังลงไปหมดกี่คันรถ พอเกลี่ยลงไปแล้วเราก็ตรวจสอบไม่ได้ บางทีก็โกยจากข้างๆ ขึ้นมา แล้วก็บอกว่าเทแล้ว ความจริงมันก็คือสไลด์ลงไป พวกนี้มีจุดรั่วไหล
            </p>
            <p>
                ส่วนพวกคอนกรีตก็คือส่วนผสมไม่ได้มาตรฐาน ถนนเสียหายเร็ว เหล็กไม่ได้ขนาด ความหนาไม่ได้ วางเหล็กไม่ได้ตามระดับเป็นไปตามที่ออกแบบ พวกนี้มีปัญหา ถนนหนา 15 เซนติเมตร เหล็กเส้นต้อง 6 มิลลิเมตร แต่บางทีกองไว้ข้างล่าง วีธิสร้างชุ่ยๆ ไม่มีลูกถ้วยรองรับ มีจุดรั่วไหลอย่างนี้
            </p>
            <p>
                ความโปร่งใส หรือไม่โปร่งใสก็คือ ถ้าเป็นวิธีเจาะจงขึ้นอยู่กับความพอใจของหน่วยงานที่เขามีข้ออ้าง เหตุผลความจำเป็น เลือกเจาะจงผู้รับจ้างได้เลย หรือชนิดยี่ห้ออะไรได้เลย โดยไม่คำนึงถึงการแข่งขัน ซึ่งความเป็นจริงจะใช้การจัดซื้อจัดจ้างแบบเฉพาะเจาะจงได้ ได้ในกรณีที่มีเหตุผลความจำเป็น ไม่ได้ใช้พร่ำเพรื่อ  ซึ่งถ้าไปอ่านใน พ.ร.บ.การจัดซื้อจัดจ้างและการบริหารพัสดุภาครัฐ พ.ศ. 2560 ใช้ได้ตามเงื่อนไข 1 2 3 4 เช่น ของที่ไม่สามารถจะเปรียบเทียบได้ ก็ใช้แบบเฉพาะเจาะจง หรือต้องการช่างมีฝีมือ หรือว่าเป็นของเฉพาะอย่างอยู่แล้ว ซึ่งก็มีไม่มากนักให้เลือกก็ต้องตรงไปตรงมา ก็ต้องเจาะจง ประกวดราคาไปก็ไม่ได้ประโยชน์ เพราะไม่มีใครมาแข่ง ถ้าจะใช้ทุกระเบียบมันจะมีปัญหา สิ่งหนึ่งที่จะมากำกับเรื่องนี้ได้ก็คือ ดูจาก พ.ร.บ.ว่าด้วยความผิดเกี่ยวกับการเสนอราคาต่อหน่วยงานของรัฐ ซึ่งจะปิดกั้นไม่ให้มีการเอื้อแก่รายหนึ่งรายใด ไม่ให้มีการเขียนสเปกเจาะจง เพื่ออุดช่องว่างตรงนี้ 
            </p>

            <p>
            เมื่อพลิกกฎหมายว่าด้วย พ.ร.บ.การจัดซื้อจัดจ้างและการบริหารพัสดุภาครัฐ พ.ศ. 2560 เขียนระบุไว้ว่า ประเภทการจัดซื้อแบบเฉพาะเจาะจง ถูกนิยามในมาตรา 82 ว่าวิธีเฉพาะเจาะจง เป็นงานจ้างออกแบบหรือควบคุมงานก่อสร้างที่หน่วยงานของรัฐเลือกจ้างผู้ให้บริการรายใดรายหนึ่ง ซึ่งเคยทราบหรือเคยเห็นความสามารถแล้ว ตามที่คณะกรรมการดําเนินงานจ้างออกแบบหรือควบคุมงานก่อสร้างโดยวิธีเฉพาะเจาะจงได้พิจารณาเสนอแนะ ทั้งนี้ให้กระทําได้ในกรณีดังต่อไปนี้
            </p>
            <ol>
                <li>ใช้ทั้งวิธีประกาศเชิญชวนทั่วไปและวิธีคัดเลือก หรือใช้วิธีคัดเลือกแล้ว แต่ไม่มีผู้ยื่นข้อเสนอ
หรือข้อเสนอนั้นไม่ได้รับการคัดเลือก
</li>
                <li>ให้ใช้กับงานจ้างที่มีวงเงินงบประมาณค่าก่อสร้างไม่เกินวงเงินตามที่กําหนดในกฎกระทรวง</li>
                <li>เป็นงานที่มีความจําเป็นเร่งด่วน หรือที่เกี่ยวกับความมั่นคงของชาติ หากล่าช้าจะเสียหายแก่หน่วยงานของรัฐ หรือความมั่นคงของชาติ</li>
                <li>เป็นงานที่จําเป็นต้องให้ผู้ให้บริการรายเดิมทําต่อจากงานที่ได้ทําไว้แล้ว เนื่องจากเหตุผลทางเทคนิค</li>
                <li>กรณีอื่นตามที่กําหนดในกฎกระทรวง</li>
            </ol>
            <p>
            คำถามข้อต่อมาคือ ความใน พ.ร.บ.การจัดซื้อจัดจ้างและการบริหารพัสดุภาครัฐ พ.ศ. 2560 ที่ระบุว่า (2) ให้ใช้กับงานจ้างที่มีวงเงินงบประมาณค่าก่อสร้างไม่เกินวงเงินตามที่กําหนดในกฎกระทรวง
สิ่งที่ต้องค้นหาต่อจากคำถามถัดไป แล้ว “วงเงินงบประมาณค่าก่อสร้าง” เท่าไร จึงจะจะสามารถจัดจ้างได้โดยด้วยวิธีการเช่นนี้ได้?

            </p>
            <p>
            คำตอบอยู่ใน กฎกระทรวงกำหนดวงเงินการจัดซื้อจัดจ้างพัสดุโดยวิธีเฉพาะเจาะจง วงเงินการจัดซื้อจัดจ้างที่ไม่ทำข้อตกลงเป็นหนังสือ และวงเงินการจัดซื้อจัดจ้างในการแต่งตั้งผู้ตรวจรับพัสดุ พ.ศ. 2560 อาศัยอํานาจตามความในมาตรา  5  วรรคหนึ่ง  มาตรา  56  วรรคหนึ่ง  (2)  (ข)  มาตรา  70 วรรคหนึ่ง  (3)  (ข)  (ง)  มาตรา  82  (2)  มาตรา  96  วรรคสอง  และมาตรา  100  วรรคสาม แห่ง พ.ร.บ.การจัดซื้อจัดจ้างและการบริหารพัสดุภาครัฐ  พ.ศ.  2560  รัฐมนตรีว่าการกระทรวงการคลัง ออกกฎกระทรวงไว้  ดังต่อไปนี้
            </p>
            <ol>
                <li>
                การจัดซื้อจัดจ้างสินค้า  งานบริการ  หรืองานก่อสร้าง  ที่มีการผลิต  จําหน่าย  ก่อสร้าง  หรือให้บริการทั่วไป  และมีวงเงินในการจัดซื้อจัดจ้างครั้งหนึ่งไม่เกิน  500,000  บาท   ให้ใช้วิธีเฉพาะเจาะจง
                </li>
                <li>
                งานจ้างที่ปรึกษาดังต่อไปนี้  ให้ใช้วิธีเฉพาะเจาะจง (1) งานจ้างที่ปรึกษาที่มีวงเงินค่าจ้างครั้งหนึ่งไม่เกิน  500,000  บาท (2) งานจ้างที่มีที่ปรึกษาในงานที่จะจ้างนั้นจํานวนจํากัดและมีวงเงินค่าจ้างครั้งหนึ่งไม่เกิน  5,000,000  บาท
                </li>
                <li>
                งานจ้างออกแบบหรือควบคุมงานก่อสร้างที่มีวงเงินงบประมาณค่าก่อสร้างครั้งหนึ่งไม่เกิน  5,000,000  บาท  ให้ใช้วิธีเฉพาะเจาะจง
                </li>
                <li>
                ในกรณีที่การจัดซื้อจัดจ้างมีวงเงินเล็กน้อยไม่เกิน  100,000  บาท  จะไม่ทําข้อตกลงเป็นหนังสือไว้ต่อกันก็ได้  แต่ต้องมีหลักฐานในการจัดซื้อจัดจ้างนั้น
                </li>
                <li>
                 ในกรณีที่การจัดซื้อจัดจ้างมีวงเงินเล็กน้อยไม่เกิน  100,000  บาท  จะแต่งตั้ง บุคคลหนึ่งบุคคลใดเป็นผู้ตรวจรับพัสดุก็ได้
                </li>
            </ol>

            <br/>
        </TextBox>
        <TextBox>
            <CreditPage/>
        </TextBox>
    </div>
}


export default Interview